import { HELP_DOCS_URL } from "@src/config";
import { useTranslation } from "react-i18next";

export default function HelpLink() {
  const { t } = useTranslation();

  return (
    <a
      href={HELP_DOCS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center px-2 text-sm text-primary underline hover:text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus"
    >
      {t("help.label")}
      <span className="sr-only">{` ${t("help.opensInNewTab")}`}</span>
    </a>
  );
}
